<template>
  <div class="row text-nowrap m-2 m-sm-4 font-italic">
    <div class="col flex-grow-1 flex-sm-grow-0 site-title-div">
      <div class="no-active-campaign">
        <h1>Админ<strong>ПЛЮС</strong></h1>
        <h2><strong>електронен дневник</strong></h2>
      </div>
    </div>
    <div class="col flex-grow-1 flex-sm-grow-0 align-self-end text-right text-sm-left">
      <div class="no-active-campaign">
        <h2>ВИ ПОЖЕЛАВА</h2>
        <h2>ВЕСЕЛИ ПРАЗНИЦИ!</h2>
      </div>
    </div>
  </div>
</template>

<script>
export default {
name: "christmas24st-main-component"
}
</script>

<style scoped>

</style>
